module.exports = __webpack_public_path__ + "img/positive-cash.405ee40b.svg";